import winterMaintanceService from "../shared/services/winterMaintanceService";
import { newNotification } from "./notificationsActions";
import { v4 as uuidv4 } from "uuid";
import fileDownload from "js-file-download";
import getDates from "../shared/services/date.service";

const REQUEST_WINTER_AREAS = "REQUEST_WINTER_AREAS";
const RESPONSE_WINTER_AREAS = "RESPONSE_WINTER_AREAS";
const REQUEST_WINTER_AREAS_FAILURE = "REQUEST_WINTER_AREAS_FAILURE";

const requestWinterAreasAction = () => {
  return {
    type: REQUEST_WINTER_AREAS,
  };
};

const responseWinterAreasAction = (data) => {
  return {
    type: RESPONSE_WINTER_AREAS,
    data,
  };
};

const requestWinterAreasFailureAction = (errors) => {
  return {
    type: REQUEST_WINTER_AREAS_FAILURE,
    errors,
  };
};

const getWinterAreas = () => {
  return (dispatch) => {
    dispatch(requestWinterAreasAction());

    winterMaintanceService
      .getWinterAreas(true)
      .then((result) => {
        dispatch(responseWinterAreasAction(result.data));
      })
      .catch((error) => {
        dispatch(requestWinterAreasFailureAction(error.response));
      });
  };
};

const REQUEST_WINTER_AREAS_SIMPLE = "REQUEST_WINTER_AREAS_SIMPLE";
const RESPONSE_WINTER_AREAS_SIMPLE = "RESPONSE_WINTER_AREAS_SIMPLE";
const REQUEST_WINTER_AREAS_SIMPLE_FAILURE = "REQUEST_WINTER_AREAS_SIMPLE_FAILURE";

const requestWinterAreasSimpleAction = () => {
  return {
    type: REQUEST_WINTER_AREAS_SIMPLE,
  };
};

const responseWinterAreasSimpleAction = (data, isExtended) => {
  return {
    type: RESPONSE_WINTER_AREAS_SIMPLE,
    data,
  };
};

const requestWinterAreasSimpleFailureAction = (errors) => {
  return {
    type: REQUEST_WINTER_AREAS_SIMPLE_FAILURE,
    errors,
  };
};

const getWinterAreasSimple = () => {
  return (dispatch) => {
    dispatch(requestWinterAreasSimpleAction());

    winterMaintanceService
      .getWinterAreas(false)
      .then((result) => {
        dispatch(responseWinterAreasSimpleAction(result.data));
      })
      .catch((error) => {
        dispatch(requestWinterAreasSimpleFailureAction(error.response));
      });
  };
};

const SET_WINTER_GROUPS_FILTER_ACTION = "SET_WINTER_GROUPS_FILTER_ACTION";

const setWinterGroupFilterAction = (winterWithoutGroupsFilter, winterGroupsFilter) => {
  return {
    type: SET_WINTER_GROUPS_FILTER_ACTION,
    winterWithoutGroupsFilter,
    winterGroupsFilter,
  };
};

const setWinterGroupFilter = (winterWithoutGroupsFilter, winterGroupsFilter) => {
  return (dispatch) => {
    dispatch(setWinterGroupFilterAction(winterWithoutGroupsFilter, winterGroupsFilter));
  };
};

const SET_WINTER_AREAS_FILTER_ACTION = "SET_WINTER_AREAS_FILTER_ACTION";

const setWinteRegionsFilterAction = (winterAreasFilter) => {
  return {
    type: SET_WINTER_AREAS_FILTER_ACTION,
    winterAreasFilter,
  };
};

const setWinterAreasFilter = (winterAreasFilter) => {
  return (dispatch) => {
    dispatch(setWinteRegionsFilterAction(winterAreasFilter));
  };
};

const REQUEST_WINTER_COMPANIES_ROUTES = "REQUEST_WINTER_COMPANIES_ROUTES";
const RESPONSE_WINTER_COMPANIES_ROUTES = "RESPONSE_WINTER_COMPANIES_ROUTES";
const REQUEST_WINTER_COMPANIES_ROUTES_FAILURE = "REQUEST_WINTER_COMPANIES_ROUTES_FAILURE";

const requestWinterCompaniesRoutesAction = () => {
  return {
    type: REQUEST_WINTER_COMPANIES_ROUTES,
  };
};

const responseWinterCompaniesRoutesAction = (data) => {
  return {
    type: RESPONSE_WINTER_COMPANIES_ROUTES,
    data,
  };
};

const requestWinterCompaniesRoutesFailureAction = (errors) => {
  return {
    type: REQUEST_WINTER_COMPANIES_ROUTES_FAILURE,
    errors,
  };
};

const SET_WINTER_ROUTES_PERSENT = "SET_WINTER_ROUTES_PERSENT";

const setWinterRoutesPercentAction = (data) => {
  return {
    type: SET_WINTER_ROUTES_PERSENT,
    data,
  };
};

const getRoute = (datas) => {
  const lines = [];
  let line = [];

  datas.forEach((data) => {
    const newLine = data["NDASTA"] !== null;
    const item = [parseFloat(data["COOY"]), parseFloat(data["COOX"])];

    if (newLine) {
      if (line.length > 3) {
        lines.push([line]);
      }

      line = [];
    }

    line.push(item);
  });

  if (line.length > 3) {
    lines.push([line]);
  }

  return lines;
};

const getRouteSensor = (datas, code) => {
  const lines = [];
  let line = [];

  datas.forEach((data) => {
    const newLine = data["NDASTA"] !== null;
    const item = [parseFloat(data["COOY"]), parseFloat(data["COOX"])];

    if (newLine) {
      if (line.length > 3) {
        lines.push([line]);
      }

      line = [];
    }

    if (data[code] !== undefined && data[code].toLowerCase() === "true") {
      line.push(item);
    } else if (!newLine && line.length > 3) {
      lines.push([line]);
      line = [];
    }

    if (data[code] !== undefined && data[code].toLowerCase() !== "true") {
      line = [];
    }
  });

  if (line.length > 3) {
    lines.push([line]);
  }

  return lines;
};

const getWinterCompaniesRoutes = (companies = [], options) => {
  return (dispatch) => {
    dispatch(requestWinterCompaniesRoutesAction());

    let responses = [];
    let errors = [];

    async function createRoute(data, isError = false) {
      if (!isError) {
        data.units.forEach((unit) => {
          unit.route = getRoute(unit.data);
          unit.routeDump = getRouteSensor(unit.data, "DU1");
          unit.routeDump2 = getRouteSensor(unit.data, "DU2");
          unit.routeSand = getRouteSensor(unit.data, "SAND");
        });

        responses = responses.concat(data);
      } else {
        errors = errors.concat(data);
      }

      const count = responses.length + errors.length;
      dispatch(setWinterRoutesPercentAction(Math.ceil((count / companies.length) * 100)));

      if (count === companies.length) {
        dispatch(responseWinterCompaniesRoutesAction(responses));
      }
    }

    companies.forEach((company) => {
      winterMaintanceService
        .getWinterCompaniesRoutes(company.id, options)
        .then((result) => {
          createRoute(result.data);
        })
        .catch((error) => {
          console.error(error);
          dispatch(
            newNotification({ id: uuidv4(), title: company.title, text: "Не удалось получить данные, повторите запрос после", level: 3 })
          );

          createRoute(error.response, true);
        });
    });
  };
};

const SET_WINTER_SENSORS_FILTER_ACTION = "SET_WINTER_SENSORS_FILTER_ACTION";

const setWinteSensorFilterAction = (winterSensorsFilter) => {
  return {
    type: SET_WINTER_SENSORS_FILTER_ACTION,
    winterSensorsFilter,
  };
};

const setWinterSensorssFilter = (winterSensorsFilter) => {
  return (dispatch) => {
    dispatch(setWinteSensorFilterAction(winterSensorsFilter));
  };
};

const SET_WINTER_ROUTE_SMOTH_FACTOR = "SET_WINTER_ROUTE_SMOTH_FACTOR";

const setWinterRouteSmoothFactorAction = (winterRouteSmoothFactor) => {
  return {
    type: SET_WINTER_ROUTE_SMOTH_FACTOR,
    winterRouteSmoothFactor,
  };
};

const setWinterRouteSmoothFactor = (winterRouteSmoothFactor) => {
  return (dispatch) => {
    dispatch(setWinterRouteSmoothFactorAction(winterRouteSmoothFactor));
  };
};

const SET_OPEN_WINTER_COMPANIES_INFO = "SET_OPEN_WINTER_COMPANIES_INFO";

const setWinteCompaniesInfoAction = (openCompaniesInfoState) => {
  return {
    type: SET_OPEN_WINTER_COMPANIES_INFO,
    openCompaniesInfoState,
  };
};

const setWinteCompaniesInfo = (openCompaniesInfoState) => {
  return (dispatch) => {
    dispatch(setWinteCompaniesInfoAction(openCompaniesInfoState));
  };
};

const SEARCH_TERM_WINTER_UNIT = "SEARCH_TERM_WINTER_UNIT";

const searchTermWinterUnitAction = (searchTerm) => {
  return {
    type: SEARCH_TERM_WINTER_UNIT,
    searchTerm,
  };
};

const searchTermWinterUnit = (searchTerm) => {
  return (dispatch) => {
    dispatch(searchTermWinterUnitAction(searchTerm));
  };
};

const SET_WINTER_POUPUP = "SET_WINTER_POUPUP";

const setWinterPoupupAction = (data) => {
  return {
    type: SET_WINTER_POUPUP,
    data,
  };
};

const setWinterPoupup = (data) => {
  return (dispatch) => {
    dispatch(setWinterPoupupAction(data));
  };
};

const SET_ROUTE_OR_REPORT_MODE_ACTION = "SET_ROUTE_OR_REPORT_MODE_ACTION";

const setRouteOrReportModeAction = (data) => {
  return {
    type: SET_ROUTE_OR_REPORT_MODE_ACTION,
    data,
  };
};

const setRouteOrReportMode = (data) => {
  return (dispatch) => {
    dispatch(setRouteOrReportModeAction(data));
  };
};

const REQUEST_WINTER_REPORT_DOWNLOAD = "REQUEST_WINTER_REPORT_DOWNLOAD";
const RESPONSE_WINTER_REPORT_DOWNLOADT = "RESPONSE_WINTER_REPORT_DOWNLOADT";
const REQUEST_WINTER_REPORT_DOWNLOAD_FAILURE = "REQUEST_WINTER_REPORT_DOWNLOAD_FAILURE";

const requestWinterReportDownloadAction = () => {
  return {
    type: REQUEST_WINTER_REPORT_DOWNLOAD,
  };
};

const responseWinterReportDownloadAction = () => {
  return {
    type: RESPONSE_WINTER_REPORT_DOWNLOADT,
  };
};

const requestWinterReportDownloadFailureAction = (errors) => {
  return {
    type: REQUEST_WINTER_REPORT_DOWNLOAD_FAILURE,
    errors,
  };
};

const winterReportDownload = (options) => {
  return (dispatch) => {
    dispatch(requestWinterReportDownloadAction());

    winterMaintanceService
      .getWinterReportsDownload(options)
      .then((result) => {
        fileDownload(result.data, "О наличии и выходе на линию специализированной уборочной техники.xlsx");
        dispatch(responseWinterReportDownloadAction());
      })
      .catch((error) => {
        dispatch(requestWinterReportDownloadFailureAction());
      });
  };
};

const REQUEST_WINTER_EOSK_REPORT_DOWNLOAD = "REQUEST_WINTER_EOSK_REPORT_DOWNLOAD";
const RESPONSE_WINTER_EOSK_REPORT_DOWNLOADT = "RESPONSE_WINTER_EOSK_REPORT_DOWNLOADT";
const REQUEST_WINTER_EOSK_REPORT_DOWNLOAD_FAILURE = "REQUEST_WINTER_EOSK_REPORT_DOWNLOAD_FAILURE";

const requestWinterEOSKReportDownloadAction = () => {
  return {
    type: REQUEST_WINTER_EOSK_REPORT_DOWNLOAD,
  };
};

const responseWinterEOSKReportDownloadAction = () => {
  return {
    type: RESPONSE_WINTER_EOSK_REPORT_DOWNLOADT,
  };
};

const requestWinterEOSKReportDownloadFailureAction = (errors) => {
  return {
    type: REQUEST_WINTER_EOSK_REPORT_DOWNLOAD_FAILURE,
    errors,
  };
};

const winterEOSKReportDownload = (options) => {
  return (dispatch) => {
    dispatch(requestWinterEOSKReportDownloadAction());

    winterMaintanceService
      .getWinterEOSKReportsDownload(options)
      .then((result) => {
        const start = getDates.getDateFormat9(options.startDate);
        const end = getDates.getDateFormat9(options.endDate);

        fileDownload(result.data, `Отчет по ЕОСК с ${start} по ${end}.xlsx`);
        dispatch(responseWinterEOSKReportDownloadAction());
      })
      .catch((error) => {
        dispatch(requestWinterEOSKReportDownloadFailureAction());
      });
  };
};

const REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD = "REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD";
const RESPONSE_WINTER_SHORT_EOSK_REPORT_DOWNLOADT = "RESPONSE_WINTER_SHORT_EOSK_REPORT_DOWNLOADT";
const REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD_FAILURE = "REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD_FAILURE";

const requestWinterShortEOSKReportDownloadAction = () => {
  return {
    type: REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD,
  };
};

const responseWinterShortEOSKReportDownloadAction = () => {
  return {
    type: RESPONSE_WINTER_SHORT_EOSK_REPORT_DOWNLOADT,
  };
};

const requestWinterShortEOSKReportDownloadFailureAction = (errors) => {
  return {
    type: REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD_FAILURE,
    errors,
  };
};

const winterShortEOSKReportDownload = (options) => {
  return (dispatch) => {
    dispatch(requestWinterShortEOSKReportDownloadAction());

    winterMaintanceService
      .getWinterShortEOSKReportsDownload(options)
      .then((result) => {
        fileDownload(result.data, `Отчет по ЕОСК.xlsx`);
        dispatch(responseWinterShortEOSKReportDownloadAction());
      })
      .catch((error) => {
        dispatch(requestWinterShortEOSKReportDownloadFailureAction());
      });
  };
};

const SET_GEOZONE_SEARCH = "SET_GEOZONE_SEARCH";

const setGeozoneSearchAction = (data, regionTitle) => {
  return {
    type: SET_GEOZONE_SEARCH,
    data,
    regionTitle,
  };
};

const setGeozoneSearch = (data, regionTitle = null) => {
  return (dispatch) => {
    dispatch(setGeozoneSearchAction(data, regionTitle));
  };
};

export {
  REQUEST_WINTER_AREAS,
  RESPONSE_WINTER_AREAS,
  REQUEST_WINTER_AREAS_FAILURE,
  getWinterAreas,
  SET_WINTER_GROUPS_FILTER_ACTION,
  setWinterGroupFilter,
  SET_WINTER_AREAS_FILTER_ACTION,
  setWinterAreasFilter,
  REQUEST_WINTER_COMPANIES_ROUTES,
  RESPONSE_WINTER_COMPANIES_ROUTES,
  REQUEST_WINTER_COMPANIES_ROUTES_FAILURE,
  getWinterCompaniesRoutes,
  SET_WINTER_SENSORS_FILTER_ACTION,
  setWinterSensorssFilter,
  SET_WINTER_ROUTES_PERSENT,
  setWinterRouteSmoothFactor,
  SET_WINTER_ROUTE_SMOTH_FACTOR,
  SET_OPEN_WINTER_COMPANIES_INFO,
  setWinteCompaniesInfo,
  SEARCH_TERM_WINTER_UNIT,
  searchTermWinterUnit,
  SET_WINTER_POUPUP,
  setWinterPoupup,
  SET_ROUTE_OR_REPORT_MODE_ACTION,
  setRouteOrReportMode,
  REQUEST_WINTER_REPORT_DOWNLOAD,
  RESPONSE_WINTER_REPORT_DOWNLOADT,
  REQUEST_WINTER_REPORT_DOWNLOAD_FAILURE,
  winterReportDownload,
  SET_GEOZONE_SEARCH,
  setGeozoneSearch,
  REQUEST_WINTER_EOSK_REPORT_DOWNLOAD,
  RESPONSE_WINTER_EOSK_REPORT_DOWNLOADT,
  REQUEST_WINTER_EOSK_REPORT_DOWNLOAD_FAILURE,
  winterEOSKReportDownload,
  REQUEST_WINTER_AREAS_SIMPLE,
  RESPONSE_WINTER_AREAS_SIMPLE,
  REQUEST_WINTER_AREAS_SIMPLE_FAILURE,
  getWinterAreasSimple,
  REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD,
  RESPONSE_WINTER_SHORT_EOSK_REPORT_DOWNLOADT,
  REQUEST_WINTER_SHORT_EOSK_REPORT_DOWNLOAD_FAILURE,
  winterShortEOSKReportDownload,
};
